import Types from "./Types";

export const getAllQuestionsBankRequest = (id) => ({
  type: Types.GET_ALL_SUPERADMIN_QUESTIONS_BANK_REQUEST,
  payload: id,
});

export const getAllQuestionsBankSuccess = (data) => ({
  type: Types.GET_ALL_SUPERADMIN_QUESTIONS_BANK_SUCCESS,
  payload: data,
});

export const getAllQuestionsBankFail = () => ({
  type: Types.GET_ALL_SUPERADMIN_QUESTIONS_BANK_FAIL,
});

export const getQuestionBankByBucketRequest = (id) => ({
  type: Types.GET_SUPERADMIN_QUESTIONS_BANK_REQUEST,
  payload: id,
});

export const getQuestionBankByBucketSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_QUESTIONS_BANK_SUCCESS,
  payload: data,
});

export const getQuestionBankByBucketFail = () => ({
  type: Types.GET_SUPERADMIN_QUESTIONS_BANK_FAIL,
});

export const editQuestionBankRequest = (formData) => ({
  type: Types.EDIT_SUPERADMIN_QUESTION_BANK_REQUEST,
  payload: formData,
});

export const editQuestionBankSuccess = (data) => ({
  type: Types.EDIT_SUPERADMIN_QUESTION_BANK_SUCCESS,
  payload: data,
});

export const editQuestionBankFail = () => ({
  type: Types.EDIT_SUPERADMIN_QUESTION_BANK_FAIL,
});

//LOADING
export const addQuestionBankLoading = (isLoading) => ({
  type: Types.ADD_SUPERADMIN_QUESTION_BANK_LOADING,
  payload: isLoading,
});

// Create QuestionBank
export const createQuestionBankRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_QUESTION_BANK_REQUEST,
  payload: formData,
  action: action,
});

export const createQuestionBankSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_QUESTION_BANK_SUCCESS,
  payload: {
    data,
  },
});

export const createQuestionBankFail = () => ({
  type: Types.CREATE_SUPERADMIN_QUESTION_BANK_FAIL,
});

export const deleteQuestionBankRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_QUESTION_BANK_REQUEST,
  payload: id,
});

export const deleteQuestionBankSuccess = (payload, result) => ({
  type: Types.DELETE_SUPERADMIN_QUESTION_BANK_SUCCESS,
  payload: { payload, result },
});

export const deleteQuestionBankFail = () => ({
  type: Types.DELETE_SUPERADMIN_QUESTION_BANK_FAIL,
});

export const bookmarkQuestionBankRequest = (id) => ({
  type: Types.BOOKMARK_SUPERADMIN_QUESTION_BANK_REQUEST,
  payload: id,
});

export const bookmarkQuestionBankSuccess = (payload, result) => ({
  type: Types.BOOKMARK_SUPERADMIN_QUESTION_BANK_SUCCESS,
  payload: { payload, result },
});

export const bookmarkQuestionBankFail = () => ({
  type: Types.BOOKMARK_SUPERADMIN_QUESTION_BANK_FAIL,
});

export const suspendQuestionBankLoading = (isLoading) => ({
  type: Types.SUSPEND_SUPERADMIN_QUESTION_BANK_LOADING,
  payload: isLoading,
});

export const bookmarkQuestionBankLoading = (isLoading) => ({
  type: Types.BOOKMARK_SUPERADMIN_QUESTION_BANK_LOADING,
  payload: isLoading,
});
